/* eslint-disable @typescript-eslint/no-explicit-any */
import apiEndpoints from '@src/lib/apiEndpoints';

import apiRequest from './api';
import { Location } from './location';
export interface Room {
  roomNumber: string;
  location: Location | undefined;
  type: string;
  capacity: string;
  maxTimeLimit: string;
  mediaSupport: string;
  roomDescription: string;
}

export const createRoom = (data: any) => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.CREATE_ROOM}`,
    data,
  });
};

export const updateRoom = (data: any, id: string) => {
  return apiRequest({
    method: 'PUT',
    url: `${apiEndpoints.UPDATE_ROOM}/${id}`,
    data,
  });
};

export const getRooms = (params: any) => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.ROOM_LIST}`,
    config: { params },
  });
};

export const getRoomById = (id: string) => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.ROOM_LIST}/${id}`,
  });
};

export const getRoomsSchedule = (params: any) => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.ROOM_LIST_SCHEDULE}`,
    config: { params },
  });
};

export const getBookings = (params: any = {}): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.BOOKINGS}`,
    config: { params },
  });
};

export const getBookingSearch = (search: string, date: any): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.BOOKINGS}/search?search=${search}&date=${date}`,
  });
};

export const deleteRoom = (id: string) => {
  return apiRequest({
    method: 'DELETE',
    url: `${apiEndpoints.DELETE_ROOM}/${id}`,
  });
};

export const updateRooms = (data: any) => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.UPDATE_ROOMS}`,
    data,
  });
};

export const uploadRoomImage = (data: any) => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.UPLOAD}`,
    contentType: 'multipart/form-data',
    data,
  });
};

export const uploadRoomPdf = (data: any) => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.UPLOAD_PDF}`,
    contentType: 'multipart/form-data',
    data,
  });
};

export const getFloorNumber = (
  location: string,
  orgID: string
): Promise<{ floorDetails: { floorNumber: number; floorMap?: string }[]; floorNotFound: boolean }> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.FLOOR_NUMBER}/${location}`,
    config: {
      params: {
        orgID,
      },
    },
  });
};

export const getFloors = (params: any): Promise<{ floors: string[] }> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.FLOOR_NUMBERS}`,
    config: { params },
  });
};

export const getRoomDeviceLogs = (params: any = {}): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.ROOM_DEVICE_LOGS}`,
    config: { params },
  });
};

export const getFloorRoomStats = (
  params: any
): Promise<{ roomState: 'default' | 'bookedNotOccupied' | 'bookedOccupied' | 'notBookedOccupied' }> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.FLOOR_ROOM_STATE}`,
    config: { params },
  });
};

export const getDynamicFloors = (): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.FLOOR_MAPPING}`,
  });
};

export const getNewBookings = (params: any = {}): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.NEW_BOOKINGS}`,
    config: { params },
  });
};

export const renderBookingData = (params: any = {}): Promise<any> => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.RENDER_BOOKING_DATA}`,
    config: { params },
  });
};
